export default {
  dashboard: {
    title: 'Workbench',
    welcome: 'Welcome back',
    refresh: 'Refresh',
    lastUpdate: 'Last updated',

    // Night welcome banner
    banner: {
      ready: 'Ready for today',
      subtitle: 'TwinStar Intelligence Platform 1.0 · AI-DRIVEN RETAIL INTELLIGENCE PLATFORM',
      computeUsage: 'Compute Usage',
      aiTasks: 'AI Tasks Running',
    },

    // KPI Cards
    kpi: {
      signingRate: 'Signing Rate',
      activeIntentions: 'Active Intentions',
      newContractsThisMonth: 'New Contracts',
      vacantShops: 'Vacant Shops',
      monthlyReceivable: 'Monthly Receivable',
      monthlyReceived: 'Monthly Received',
      collectionRate: 'Collection Rate',
      overdueAmount: 'Overdue Amount',
      operatingMerchants: 'Operating Merchants',
      renovatingCount: 'Renovating',
      openingRate: 'Opening Rate',
      myTaskTotal: 'My Tasks',
      myTaskCompleted: 'Completed',
      myTaskDueThisWeek: 'Due This Week',
      myCompletionRate: 'Completion Rate',
      pendingWorkOrders: 'Pending Orders',
      urgentWorkOrders: 'Urgent Orders',
      todayWorkOrders: 'New Today',
      overdueWorkOrders: 'Overdue Orders',
      unitYuan: 'CNY',
      unitCount: ''
    },

    // Todos
    todo: {
      title: 'To-Do',
      all: 'All',
      overdue: 'Overdue',
      expiring: 'Expiring',
      approval: 'Approval',
      rejected: 'Rejected',
      task: 'Tasks',
      empty: 'No pending items',
      viewAll: 'View All',
      overdueDays: '{days} days overdue',
      dueDateLabel: 'Due date'
    },

    // Quick Actions
    quick: {
      title: 'Quick Actions',
      merchantWorkbench: 'Merchant Workbench',
      contractManage: 'Contracts',
      billingManage: 'Billing',
      renovationManage: 'Renovation',
      policyManage: 'Policies',
      brandLibrary: 'Brands',
      feeEntry: 'Fee Entry',
      financeReport: 'Finance Report',
      salesReport: 'Sales Report',
      workorderManage: 'Work Orders',
      createWorkorder: 'New Work Order'
    },

    // Notifications
    notification: {
      title: 'Notifications',
      typeAll: 'All',
      typeBusiness: 'Business',
      typeApproval: 'Approval',
      typeSystem: 'System',
      markAllRead: 'Mark All Read',
      markRead: 'Mark as Read',
      noNotification: 'No notifications',
      viewAll: 'View All',
      unreadCount: '{count} unread'
    },

    // Charts
    chart: {
      todoDistribution: 'Todo Distribution',
      shopOverview: 'Shop Overview'
    }
  }
}
